import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx, renderList as _renderList, createSlots as _createSlots, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "components__rec-tabbed-conted" }

import { computed } from 'vue';

 import { recProps } from "../../mixins/rec-component";
 
 import TabbedContent from "vue/applications/frontend/components/tabbed-content.vue"

 
export default /*#__PURE__*/_defineComponent({
  __name: 'rec-tabbed-content',
  props: {...recProps()},
  emits: ["submit"],
  setup(__props) {

 const props = __props;
 

 const tabHeaders = computed(() => {
  const result: Record<string, string> = {};
  for (const tab of props.description.tabs || []) {
    result[tab.key] = tab.heading;
  }
  return result;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(TabbedContent, { "tab-headers": tabHeaders.value }, _createSlots({ _: 2 }, [
      _renderList(_ctx.description.tabs, (tab) => {
        return {
          name: tab.key,
          fn: _withCtx(() => [
            (_openBlock(), _createBlock(_resolveDynamicComponent(tab.content.component), {
              description: tab.content,
              onSubmit: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('submit')))
            }, null, 40, ["description"]))
          ])
        }
      })
    ]), 1032, ["tab-headers"])
  ]))
}
}

})